import { storage } from "../firebase";
import {
  ref,
  uploadBytesResumable,
  getDownloadURL
} from "firebase/storage";

export async function uploadToStorage(path, file, onProgress) {
  return new Promise((resolve, reject) => {
    const storageRef = ref(storage, path);
    const task = uploadBytesResumable(storageRef, file);

    task.on(
      "state_changed",
      snap => {
        if (onProgress) {
          const p = Math.round((snap.bytesTransferred / snap.totalBytes) * 100);
          onProgress(p);
        }
      },
      reject,
      async () => {
        const url = await getDownloadURL(task.snapshot.ref);
        resolve(url);
      }
    );
  });
}
